<div class="container auth-container">
  <div class="auth-card">
    <h2 class="auth-title">Şifrəni yenilə</h2>

    <div *ngIf="successMessage" class="success-message" style="color: #4caf50; margin-bottom: 15px; text-align: center;">
      {{ successMessage }}
    </div>

    <div *ngIf="errorMessage" class="error-message general-error" style="color: #d32f2f; margin-bottom: 15px; text-align: center;">
      {{ errorMessage }}
    </div>

    <form *ngIf="!successMessage" [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="auth-form">
      <div class="form-group">
        <label for="password">Yeni şifrə</label>
        <div class="password-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            formControlName="password"
            placeholder="Şifrənizi daxil edin"
            [class.invalid]="resetForm.get('password')?.invalid && resetForm.get('password')?.touched"
          >
          <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
            <i class="icon" [class.icon-show]="!showPassword" [class.icon-hide]="showPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="resetForm.get('password')?.invalid && resetForm.get('password')?.touched">
          <span *ngIf="resetForm.get('password')?.errors?.['required']">Şifrə daxil edilməlidir.</span>
          <span *ngIf="resetForm.get('password')?.errors?.['minlength']">Şifrə ən azı 6 simvol olmalıdır.</span>
        </div>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Yeni şifrəni təkrarla</label>
        <div class="password-wrapper">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Şifrəni təkrar daxil edin"
            [class.invalid]="(resetForm.get('confirmPassword')?.invalid || resetForm.errors?.['mismatch']) && resetForm.get('confirmPassword')?.touched"
          >
          <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()">
            <i class="icon" [class.icon-show]="!showConfirmPassword" [class.icon-hide]="showConfirmPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="resetForm.get('confirmPassword')?.touched">
          <span *ngIf="resetForm.get('confirmPassword')?.errors?.['required']">Şifrəni təkrar daxil edin.</span>
          <span *ngIf="resetForm.errors?.['mismatch']">Şifrələr uyğun deyil.</span>
        </div>
      </div>

      <button type="submit" class="btn-submit" [disabled]="resetForm.invalid || isLoading || !phone || !otpCode">
        {{ isLoading ? 'Yenilənir...' : 'Şifrəni yenilə' }}
      </button>
    </form>
  </div>
</div>
